import React, { useState, useEffect } from "react";
import {
Col,
Row,
Typography,
Button,
Input,
Form,
Select,
Checkbox,
Skeleton,
InputNumber,
Divider } from
"antd";

import { EditOutlined, LoadingOutlined, PlusOutlined } from "@ant-design/icons";
import { FiPlus } from "react-icons/fi";
import deleteicon from "../../../../../assets/img/deleteicon.png";
import Editor from "../../../../../components/TextEditor/textEditor";
import {
resetCreateGig,
updateJobs,
updateJobsReset } from
"../../../../../redux/actions";
import { useDispatch, useSelector } from "react-redux";
import history from "../../../../../routes/history";
import { useLocation } from "react-router-dom";
import TopAlert from "../../../../../components/TopNotification/TopAlert";
import { setCookie, isHC, isNonHC } from "../../../../../shared/helpers";
import PrivateGigButton from "../PrivateGigButton/PrivateGigButton";
import TaxTerm from "./TaxTerm";
import "./fromSecondPart.css";

const FromSecondPart = () => {
  const { Text } = Typography;
  const { TextArea } = Input;
  const { Option } = Select;
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const location = useLocation();
  const GigId = location?.state?.GigId;
  const JobOrderId = location?.state?.JobOrderId;
  const FromEdit = location?.state?.FromEdit;
  const Title = location?.state?.Title;
  const FacilityName = location?.state?.FacilityName;
  const Skills = location?.state?.Skills;
  const Experience = location?.state?.Experience;
  const Industry = location?.state?.Industry;
  // const Description = location?.state?.Description;
  // const WorkAuthorization = location.state.WorkAuthorization;
  const isTemplate = location?.state?.isTemplate;
  const Location = location?.state?.Location;
  const Duration = location?.state?.IdealContractLengthName;
  const BudgetMin = location?.state?.BudgetMin;
  const BudgetType = location?.state?.BudgetType;
  const Role = location?.state?.Role;
  const workpolicy = location?.state?.workpolicy;
  const [error, setError] = useState(false);

  //********** convert encrypted html code to HTML tags **********
  var cache = {},
    character,
    e = document.createElement("div");

  const msgtxt = (html) => {
    return html?.replace(/([&][^&; ]+[;])/g, function (entity) {
      character = cache[entity];
      if (!character) {
        e.innerHTML = entity;
        if (e.childNodes[0])
        character = cache[entity] = e.childNodes[0].nodeValue;else
        character = "";
      }
      return character;
    });
  };
  //*********************************************//

  //Hooks
  const [Description, setDescription] = useState(
  FromEdit ?
  location.state.Description && msgtxt(location.state.Description) :
  " ");

  const [taxTermValue, setTaxTermValue] = useState(
  FromEdit ? location.state.IdealTerms : []);

  const [openPositions, setOpenPositions] = useState(
  FromEdit && location.state.openPositions);

  const [WorkAuthorization, setWorkAuthorization] = useState(
  workpolicy !== "fully-remote" ?
  FromEdit && location.state.WorkAuthorization :
  null);

  const [certificates, setCertificates] = useState([]);
  const [addCertificate, setAddCertificate] = useState("");
  const [addCertifiateInput, setAddCertificateInput] = useState("none");
  const [inputDisable, setInputDisable] = useState(true);
  const [editIndex, setEditIndex] = useState();
  const [editPressed, setEditPressed] = useState(false);
  const [saveOnce, setSaveOnce] = useState(0);
  const [empty, setEmpty] = useState("");
  const [windowDimensions, setWindowDimensions] = useState(
  getWindowDimensions());

  const [loading, setLoading] = useState(false);
  const [publishBtnClick, setPublishBtnCick] = useState(false);
  const [saveAsTemplate, setSaveAsTemplate] = useState(
  FromEdit ? location.state.saveAsTemplate : false);

  const [saveAlert, setSaveAlert] = useState(false);
  const [unsaveAlert, setunSaveAlert] = useState(0);
  const [msgCounter, setMsgCounter] = useState(0);
  const [ButtonSelected, setButtonSelected] = useState(false);
  const professionCode = useSelector(
  (state) => state.profileReducer.user.profile.ProfessionCode);

  // const createdGig = useSelector(state=> state.createGigReducer.gig)
  let userProfile = JSON.parse(localStorage.getItem("userProfile"));
  const updateLoading = useSelector((state) => state.UpdateJobReducer.loading);
  const updateSuccess = useSelector((state) => state.UpdateJobReducer.success);
  const updateJobsred = useSelector((state) => state.UpdateJobReducer.jobs);
  const createGigresp = useSelector((state) => state.createGigReducer.gig);
  useEffect(() => {
    if (FromEdit == true || FromEdit == "true") {
      if (location.state.certificates?.length > 0) {
        var certificates_ = [];
        location.state.certificates.map((items, index) => {
          certificates_.push(items);
        });

        setCertificates(certificates_);
      }
    }
  }, []);

  const setCertificate = (e) => {
    if (e.target.value !== undefined) setAddCertificate(e.target.value);
    setEmpty(e.target.value);
  };
  const addCertification = (index) => {
    if (addCertificate?.trim().length !== 0) {
      setEmpty("");

      if (editIndex != undefined) {
        var newArray = certificates.splice(editIndex, 1, addCertificate);
        setAddCertificate("");
      } else if (addCertificate?.length > 0) {
        // setCertificates([...certificates, addCertificate]);
        setCertificates([...certificates, addCertificate]);
        setAddCertificate("");
      }
      setEditIndex();
      setAddCertificateInput("none");
      setEditPressed(false);
      // newArray=[];
    }
  };

  const editCertification = (e) => {
    if (e.key === "Enter") {
      setCertificates([...certificates, addCertificate]);
      // setInputDisable(true)
    }
  };
  const deleteElement = (index) => {
    certificates.splice(index, 1);
    setCertificates([...certificates]);
    setLoading(true);
    setAddCertificate();
    // setTimeout(()=>setLoading(true));
    // setInputDisable(false);
    setEditPressed(false);
  };

  useEffect(() => {
    setTimeout(() => setLoading(false), 1000);
  }, [loading]);

  const onFinish = (values) => {
    values.Certifications = certificates;
    setPublishBtnCick(true);
    setCookie("finishProfile", "true");
    // dispatch(updateJobs({...values, id:FromEdit ? GigId :createdGig._id, JobOrderStatusName:'Published'}))

    dispatch(
    updateJobs({
      ...values,
      WorkAuthorization: WorkAuthorization,
      // id: GigId,
      id: location.state?.FromEdit ? location.state.Id : JobOrderId,
      // JobOrderId: location.state.JobOrderId,
      // JobOrderId: GigId,
      JobOrderId: location.state?.FromEdit ? location.state.Id : JobOrderId,
      JobOrderStatusName: "Published",
      templateType: values.isTemplate ? "saved" : null,
      isTemplate: saveAsTemplate,
      BudgetMin: BudgetMin,
      BudgetTypeName: BudgetType,
      ProfessionCode: userProfile?.profile?.ProfessionCode,
      isTemplate: saveAsTemplate ? true : false,
      templateType: saveAsTemplate ? "saved" : null,
      Location: workpolicy !== "fully-remote" ? location.state?.locobj : null,
      Position: openPositions,
      Description: Description,
      isPrivate: ButtonSelected,
      IdealTerms: taxTermValue
    }));

    setTimeout(() => {
      dispatch(updateJobsReset());
    }, [3000]);
  };

  const handleEdit = (index) => {
    setEditPressed(true);
    setEditIndex(index);
    if (index === editIndex) {
      setInputDisable(false);
    }
    setAddCertificate(certificates[index]);
  };
  useEffect(() => {
    dispatch(updateJobsReset());
    if (updateSuccess && publishBtnClick) {
      setTimeout(() => {
        history.go(-4);
        setTimeout(() => {
          history.push({
            pathname: `/jobdetail/${
            location.state?.FromEdit ? location.state.Id : JobOrderId
            }`,
            state: {
              id: location.state?.FromEdit ? location.state.Id : JobOrderId,
              img: location.state.img
            }
          });
        }, 50);
      }, 100);
    }
  }, [updateSuccess]);

  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height
    };
  }

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const previousHandler = () => {
    history.push({
      pathname: "/contract-gig",
      // isHC(userProfile?.Professions?.ProfessionCode)
      // ? "/postjob/budgetform"
      // : "/contract-gig",

      state: {
        ...(location?.state || {}),
        Title: Title,
        FacilityName: FacilityName,
        Skills: Skills,
        Location: Location,
        Experience: location.state.Experience?.sort(
        (a, b) => a.ExperienceLevelId - b.ExperienceLevelId),

        Industry: Industry,
        Id: GigId,
        GigId: location.state.GigId,
        Description: Description,
        WorkAuthorization: WorkAuthorization,
        Location: location?.state?.locobj?.LocationWithCountry,
        isTemplate: isTemplate,
        FromEdit:
        isHC(userProfile?.profile?.ProfessionCode) ? FromEdit : true,
        IdealContractLengthName: Duration,
        BudgetMin: BudgetMin,
        BudgetType: BudgetType,
        Role: Role,
        employerName: location.state.employerName,
        WorkPolicy: workpolicy,
        certificates: certificates,
        PermanentJob: location.state.PermanentJob,
        saveAsTemplate: saveAsTemplate,
        JobOrderTypeName: location.state.JobOrderType,
        locobj: location.state.locobj,
        placeId: location.state.placeId,
        JobOrderId: location.state.JobOrderId,
        NotTemplate: true,
        openPositions: openPositions
      }
    });
  };

  const handleChange = (val) => {
    setWorkAuthorization(val);
  };

  const handleTaxTermValue = (value) => {
    setTaxTermValue(value);
  };

  return (
    <>
      {saveAlert ?
      <TopAlert
      display={"flex"}
      title={"Template successfully saved"}
      type="success" /> :

      null}

      {unsaveAlert === 1 && saveAlert === false ?
      <TopAlert
      display={"flex"}
      title={"Job removed from Template"}
      type="success" /> :

      null}
      <Col
      className={
      windowDimensions.width > 769 ? "form-parent" : "mobile-form-parnet"}

      xs={24}
      lg={24}>
        
        <Col
        className={`from-div ${
        workpolicy !== "fully-remote" ? "from-div-Section-pvt" : null
        }`}>
          
          <Form
          form={form}
          initialValues={{
            IdealTerms: FromEdit ? location.state.IdealTerms : [],
            Description: FromEdit ? location.state.Description : "",
            WorkAuthorization:
            FromEdit && location.state.WorkAuthorization ?
            location.state.WorkAuthorization :
            undefined,
            // isTemplate: FromEdit ? location.state.isTemplate : false,
            Certifications: FromEdit ? location.state.certifications : null,
            Positions: FromEdit ? location.state?.openPositions : null
          }}
          onFinish={onFinish}
          layout="vertical">
            
            {isNonHC(userProfile?.Professions?.ProfessionCode) ?
            <Form.Item
            name={"Certifications"}
            label={
            <div className="certificate-label">
                    Certifications
                    {/* <strong>*</strong> */}
                  </div>}>

              
                <Col xs={24} lg={14} className="certificate-column">
                  <div className="certificate-text">
                    Add list of certifications required
                  </div>
                  {certificates?.length ?
                loading ?
                <Skeleton /> :

                <div className="certificate-input-div">
                        {certificates.map((certificates, index) => {
                    return (
                      <>
                              <Row key={index}>
                                <Col xs={18}>
                                  <Input
                            className="added-certificates"
                            // onKeyPress={editCertification}
                            disabled={editIndex == index ? false : true}
                            defaultValue={certificates}
                            onChange={setCertificate}
                            onKeyPress={(event) => {
                              if (event.which === 13 /* Enter */) {
                                event.preventDefault();
                              }
                            }} />
                            
                                </Col>

                                {!editIndex && !editPressed ? //undefined //false
                          <Col className="actions-div" xs={6}>
                                    {/* <img className="action-icon" src={editicon}/> */}
                                    <img
                            className="action-icon"
                            src={deleteicon}
                            onClick={() => deleteElement(index)} />
                            
                                    <EditOutlined
                            className="action-icon edit-icon"
                            onClick={() => handleEdit(index)} />
                            
                                    {/* <Button onClick={addCertification} className="certificate-btn">Add</Button> */}
                                  </Col> :

                          editIndex === index &&
                          editPressed &&
                          <Button
                          onClick={() => {
                            addCertification(index);
                          }}
                          className="certificate-btn2">
                            
                                      Add
                                    </Button>}

                          
                              </Row>
                            </>);

                  })}
                        <Row
                  style={{
                    display: addCertifiateInput,
                    flexDirection: "row",
                    width: "100%"
                  }}>
                    
                          <Col xs={24}>
                            <Input
                      size="large"
                      style={{ width: "70%" }}
                      onChange={setCertificate}
                      type={"input"}
                      placeholder="Certificate Name"
                      value={empty}
                      onKeyPress={(event) => {
                        if (event.which === 13 /* Enter */) {
                          event.preventDefault();
                        }
                      }} />
                      
                            <Button
                      onClick={addCertification}
                      className="certificate-btn2">
                        
                              Add
                            </Button>
                          </Col>
                        </Row>
                        <div>
                          <div
                    style={{
                      background: "#e3e3e3",
                      height: "1px",
                      marginBottom: ".5rem",
                      marginTop: "1.2rem"
                    }} />
                    
                          <Button
                    className="add-new-certificate-btn"
                    onClick={() => {
                      setAddCertificateInput("block");
                      setAddCertificate("");
                      setEmpty("");
                    }}>
                      
                            <Row>
                              <Col className="plus-icon" xs={4}>
                                +
                              </Col>
                              <Col style={{ paddingTop: "4px" }} xs={20}>
                                <Text className="addnewcertificatebtn-text">
                                  Add new Certification
                                </Text>
                              </Col>
                            </Row>
                          </Button>
                        </div>
                      </div> :


                <Row className="certificate-input-div">
                      <Col xs={18}>
                        <Input
                    size="large"
                    className="certificate-input"
                    onChange={setCertificate}
                    type={"input"}
                    placeholder="Certificate Name"
                    onKeyPress={(event) => {
                      if (event.which === 13 /* Enter */) {
                        event.preventDefault();
                      }
                    }} />
                    
                      </Col>
                      <Col xs={6}>
                        <Button
                    onClick={() => {
                      addCertification(0);
                    }}
                    className="certificate-btn2">
                      
                          Add
                        </Button>
                      </Col>
                    </Row>}
                
                </Col>
              </Form.Item> :
            null}

            <Form.Item
            name="Description"
            label={
            <div className="description-label">
                  Job description <strong>*</strong>
                </div>}

            rules={[
            {
              validator: (_, value) => {
                if (msgCounter > 0) {
                  setError(false);
                  return Promise.resolve();
                } else {
                  setError(true);
                  return Promise.reject(
                  new Error("Add a description of the job"));

                }
              }
            }]}>

              
              <div className="from-div-test">
                <Editor
                text={Description}
                error={error}
                setError={setError}
                changeText={(text) => {
                  setDescription(text);
                  if (text) {
                    form.validateFields(["Description"]);
                  }
                }}
                counter={(val) => {
                  setMsgCounter(val);
                }}
                placeholder={
                "Add a description of the ideal candidate  you’re looking to hire and list some job responsibilities..."}

                FromSellJob={true}
                FromPostAJob={false} />
                
              </div>
            </Form.Item>
            <div
            className={`workAuth-position-div ${
            workpolicy !== "fully-remote" ? "workAuth-fully-remote" : null
            }`}>
              
              {workpolicy !== "fully-remote" &&
              <div className={"WorkAuthorization-div"}>
                  <Form.Item
                className="select-item"
                name="WorkAuthorization"
                rules={[
                {
                  required: true,
                  message: "Choose your work authorization"
                }]}

                label={
                <Text className="authorization-label">
                        Work authorization <strong>*</strong>
                      </Text>}>

                  
                    <Select
                  defaultValue={
                  FromEdit && location.state.WorkAuthorization ?
                  location.state.WorkAuthorization :
                  undefined}

                  // placeholder="Citizen, Resident/Citizen"
                  placeholder="Choose your work authorization"
                  onChange={handleChange}
                  mode="multiple"
                  style={{ border: "1px solid #d9d9d9", padding: "4px" }}>
                    
                      <Option value={"US Resident/Citizen"}>
                        US Resident/Citizen
                      </Option>
                      <Option value={"EAD"}>EAD</Option>
                      <Option value={"H1-B"}>H1-B</Option>
                    </Select>
                  </Form.Item>
                </div>}
              
              <div className={"positions-div"}>
                <Form.Item
                className="select-item"
                name="Positions"
                rules={[
                {
                  validator: (_, value) => {
                    if (/^[+0-9]+$/.test(value) && Number(value) > 0) {
                      if (Number(value) > 5000) {
                        return Promise.reject(
                        new Error("Positions cannot be more than 5000"));

                      } else {
                        return Promise.resolve();
                      }
                    } else {
                      if (Number(value) < 0) {
                        return Promise.reject(
                        new Error("Please enter valid no of positions"));

                      }
                      return Promise.reject(
                      new Error("Please enter number of open positions"));

                    }
                  }
                }]}

                label={
                <Text className="authorization-label">
                      Total open positions <strong>*</strong>
                    </Text>}>

                  
                  <Input
                  addonBefore={null}
                  addonAfter={null}
                  defaultValue={FromEdit ? location.state?.openPositions : 1}
                  placeholder="Positions"
                  type={"number"}
                  onChange={(e) => {
                    setOpenPositions(parseInt(e.target.value));
                  }}
                  allowClear
                  className="NumInputField" />
                  
                </Form.Item>
                {
                userProfile?.IsPrivateEmployer &&
                <Form.Item
                className="select-item"
                label={
                <Text className="authorization-label">
                          Job visibility <strong>*</strong>
                        </Text>}>

                  
                      <PrivateGigButton
                  ButtonSelected={ButtonSelected}
                  setButtonSelected={setButtonSelected} />
                  
                    </Form.Item>}
                
              </div>
            </div>
              <div>
                <TaxTerm handleValue={handleTaxTermValue} />
              </div>
            <Row>
              <Divider className="Divider-mobile" />
            </Row>
            <div className="form-footer-section">
              <div className="footer-check-box">
                <Checkbox
                onChange={() => {
                  setSaveAsTemplate(!saveAsTemplate);
                  setSaveAlert(!saveAsTemplate);
                  setunSaveAlert(1);
                  dispatch(
                  updateJobs({
                    // id: GigId,
                    id: JobOrderId,
                    isTemplate: !saveAsTemplate,
                    templateType: !saveAsTemplate ? "saved" : "default",
                    Location:
                    workpolicy !== "fully-remote" ?
                    location.state?.locobj :
                    null
                  }));

                }}
                checked={saveAsTemplate}>
                  
                  Save this job as a template
                </Checkbox>
              </div>
              <Form.Item>
                <Row className="buttons-row">
                  <Col xs={12} lg={8}>
                    <Button className="btns" onClick={previousHandler}>
                      <Text className="text">Previous</Text>
                    </Button>
                  </Col>

                  <Col xs={12} lg={8}>
                    <Button htmlType="submit" className="publishbtns">
                      <Text className="text">
                        {updateLoading && publishBtnClick ?
                        <LoadingOutlined /> :

                        "Publish Job"}
                        
                      </Text>
                    </Button>
                  </Col>
                </Row>
              </Form.Item>
            </div>
          </Form>
        </Col>
      </Col>
    </>);

};
export default FromSecondPart;